import {FC, useState, useEffect} from 'react'
import {FieldError, FieldErrors, FieldValues} from 'react-hook-form'
import {Section} from 'jbc-front/components/presenters/form/Section'
import {ErrorMessage} from 'jbc-front/components/presenters/form/ErrorMessage'

interface FormError {
  path: string
  message: string
}

type FormErrorsProps = {
  errors: FieldErrors
  isSubmitting: boolean
}

export const FormErrors: FC<FormErrorsProps> = ({errors, isSubmitting}) => {
  const [errorMessages, setErrorMessages] = useState<string[]>([])

  useEffect(() => {
    const formErrors = [...flattenErrors(errors)]

    if (formErrors.length > 0) {
      setErrorMessages(formErrors.map((error) => error.message))
    }
  }, [isSubmitting])

  return errorMessages.length > 0 ? (
    <Section title="入力内容に誤りがあります" error>
      {errorMessages.map((message, index) => (
        <ErrorMessage key={index}>{message}</ErrorMessage>
      ))}
    </Section>
  ) : (
    <></>
  )
}

const isFieldError = (obj: object): obj is FieldError => 'type' in obj && 'message' in obj

const flattenErrors = function* <TFieldValues extends FieldValues>(
  errors: FieldErrors<TFieldValues>,
  path: (string | number)[] = []
): Generator<FormError> {
  if (Array.isArray(errors)) {
    for (let index = 0; index < errors.length; index++) {
      yield* flattenErrors(errors[index], [...path, index])
    }
  } else if (isFieldError(errors)) {
    yield {
      ...errors,
      path: path.reduce((p, c) => (typeof c === 'number' ? `${p}[${c}]` : `${p}.${c}`)) as string,
      message: errors.message || '',
    }
  } else {
    for (const key in errors) {
      yield* flattenErrors(errors[key] as FieldErrors, [...path, key])
    }
  }
}
